/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsEetsOrderRequestTemplateData } from '../../models/mail-params-eets-order-request-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendEetsOrderRequestMail$Params {
      body: MailParamsEetsOrderRequestTemplateData
}

export function sendEetsOrderRequestMail(http: HttpClient, rootUrl: string, params: SendEetsOrderRequestMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendEetsOrderRequestMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendEetsOrderRequestMail.PATH = '/sendMail/eets-order-request';
